import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NegotiationEditModalService {

  private selectedNegotiationSubject = new BehaviorSubject<any>(null);
  public selectedNegotiation$ = this.selectedNegotiationSubject.asObservable();

  constructor() { }

  setSelectedNegotiation(negotiation: any): void {
    this.selectedNegotiationSubject.next(negotiation);
  }

  getSelectedNegotiation(): any | null {
    return this.selectedNegotiationSubject.value;
  }

  clearSelectedNegotiation(): void {
    this.selectedNegotiationSubject.next(null);
  }
}

